import { render, staticRenderFns } from "./RoleNameModal.vue?vue&type=template&id=b5db2676&scoped=true"
import script from "./RoleNameModal.vue?vue&type=script&lang=js"
export * from "./RoleNameModal.vue?vue&type=script&lang=js"
import style0 from "./RoleNameModal.vue?vue&type=style&index=0&id=b5db2676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5db2676",
  null
  
)

export default component.exports